export default __webpack_public_path__ + "static/16-1d7ec90a775f2b4526488f0009985f41.webp";